<template>
   <div>

    <el-row :gutter="24">

    <el-col :sm="24" :md="12" :lg="8">
      <br >
      <el-card shadow="hover">
        <template #header><div class="clearfix">
          <span class="text-info"><i class="fa fa-info" />&nbsp;Info</span>
        </div></template>

        <table class="el-table">
          <tr v-if="siteData.candidate">
            <td>Client:</td><td>
              <el-row type="flex" justify-center>
                <el-col>
                  <org-badge :organisation="siteData.candidate" />
                </el-col>

                <el-col>
                  <contacts-popover :row-data="siteData" org-prop="candidate" />
                </el-col>
               </el-row>
            </td>
          </tr>

          <tr>
            <!-- eslint-disable-next-line vue/no-v-html -- formatter output, developer-controlled HTML (enum → icon markup) -->
            <td>Status:</td><td><span v-html="this.siteStatus(siteData.status)"></span></td>
          </tr>
          <tr v-if="siteData.active || (siteData.dismantled && siteData.status == 'Dismantled')" :class="!siteData.dismantled ? 'text-success' : 'text-danger'">
            <td>{{siteData.dismantled ? 'Dismantled:' : 'Active'}}</td><td><strong>{{formatDate(!siteData.dismantled ? siteData.active : siteData.dismantled)}}</strong></td>
          </tr>
          <tr v-if="siteData.handover">
            <td>Handover:</td><td><strong>{{formatDate(siteData.handover)}}</strong>&nbsp;(<i>{{formatFriendlyDate(siteData.handover)}}</i>)</td>
          </tr>
          <tr>
            <td>Site ID:</td><td><span class="text-black">{{siteData.siteId}}</span><b class="text-primary" v-if="siteData.telcoSiteId">&nbsp;|&nbsp;{{siteData.telcoSiteId}}</b></td>
          </tr>
          <tr v-if="siteData.structure && siteData.structure.name">
            <td>Structure:</td><td><strong>{{siteData.structure.name}}<span>&nbsp;|&nbsp;{{siteData.structure.height}}m.</span></strong></td>
          </tr>
          <tr v-if="siteData.coverage && isTowerCo()">
            <td>Coverage:</td><td><strong>{{siteData.coverage}}</strong></td>
          </tr>
          <tr v-if="siteData.siteGroup && isTowerCo()">
            <td>Site Group:</td><td><strong>{{siteData.siteGroup}}</strong></td>
          </tr>
          <tr v-if="siteData.onAir" class="text-primary">
            <td>On Air:</td><td><strong>{{formatDate(siteData.onAir)}}</strong>&nbsp;(<i>{{formatFriendlyDate(siteData.onAir)}}</i>)</td>
          </tr>
<!--
          <tr v-if="isTowerCo() && (!siteData.active && siteData.status === this.activeSite()) || (!siteData.dismantled  && siteData.status === this.dismantledSite())">
            <td>Save {{siteData.status === this.activeSite() ? 'Active' : 'Dismantled'}}</td>
            <td>
              <span v-if="isTowerCo() && isManager('project')">
                <span v-if="!siteData.active && siteData.status === this.activeSite()">
                  <el-tooltip placement="right">
                    <template #content><div>
                      <span v-if="siteData.handover">Handover on <b>{{this.formatDate(siteData.handover)}}</b><br /></span>
                      <span v-if="siteData.updated_at">Last update on <b>{{this.formatDate(siteData.updated_at)}}</b> <span v-if="siteData.updated_by"> by {{siteData.updated_by}}</span><br /></span>
                      <span v-if="siteData.created_at">Created on <b>{{this.formatDate(siteData.created_at)}}</b><br /></span>
                    </div></template>
                    <el-date-picker value-format="yyyy-MM-dd" size="mini" v-model="siteData.active" />
                  </el-tooltip>
                </span>
                <span v-if="!siteData.dismantled && siteData.status === this.dismantledSite()">
                  <el-date-picker value-format="yyyy-MM-dd" size="mini" v-model="siteData.dismantled" />
                </span>
                <el-button type="success" size="mini" icon="fa fa-check" @click="saveSite(siteData)" />
              </span>
            </td>
          </tr>
-->
        </table>

      </el-card>

    </el-col>

    <el-col v-if="hasStats && (isTowerCo() || isTelco()) && !isCandidate(siteData.status)" :sm="24" :md="12" :lg="8">
      <br >
      <el-card shadow="hover">
        <template #header><div class="clearfix">
          <span class="text-primary"><i class="fa fa-chart-line" />&nbsp;Stats</span>
        </div></template>

          <table class="el-table">
             <tr v-if="isTowerCo() && canAccess('project|maintenance|finance|management') && siteData.stats.orgName">
                <td><i class="fa fa-user" />&nbsp;PM:</td><td>
                 <org-badge :short-name="siteData.stats.orgName" :color="siteData.stats.colourCode" />
               </td>
            </tr>
              <tr v-if="siteData.stats.sharers">
                <td><i class="fa fa-users" />&nbsp;Telcos:</td><td>
                  <el-button v-if="isTowerCo() && canAccess('project|maintenance|finance|management')" type="success" size="mini" plain round @click="menu('sharers')">{{siteData.stats.sharers}}</el-button>
                  <strong v-else>{{siteData.stats.sharers}}</strong>
                </td>
              </tr>
              <tr v-if="siteData.stats.terminatedSharers && isTowerCo()">
                <td><i class="fa fa-user-slash" />&nbsp;Terminated:</td><td>
                  <el-button v-if="isTowerCo() && canAccess('project|maintenance|finance|management')" type="danger" size="mini" plain round @click="menu('sharers')">{{siteData.stats.terminatedSharers}}</el-button>
                  <strong v-else>{{siteData.stats.terminatedSharers}}</strong>
                </td>
              </tr>
              <tr v-if="siteData.stats.tickets && (isTelco() || canAccess('project|maintenance|management'))">
                <td><i class="fa fa-headset" />&nbsp;Tickets:</td><td>
                  <el-button type="warning" size="mini" plain round @click="menu('maint')">{{siteData.stats.tickets}}</el-button>
                </td>
              </tr>
              <tr v-if="siteData.stats.assets">
                <td><i class="fa fa-cogs" />&nbsp;Equipment:</td><td>
                  <el-button type="info" size="mini" plain round @click="menu('equip')">{{siteData.stats.assets}}</el-button>
                </td>
              </tr>
              <tr v-if="siteData.stats.permits && isTowerCo() && canAccess('project|property|finance|admin|management')">
                <td><i class="fa fa-clipboard" />&nbsp;Permits:</td><td>
                  <el-button type="info" size="mini" plain round @click="menu('permits')">{{siteData.stats.permits}}</el-button>
                </td>
              </tr>
              <tr v-if="siteData.stats.actions && isTowerCo() && !isLandOnly(siteData.status) && canAccess('project|maintenace|finance|admin')">
                <td><i class="fa fa-asterisk" />&nbsp;Actions:</td><td>
                  <el-button type="primary" size="mini" plain round @click="menu('actions')">{{siteData.stats.actions}}</el-button>
                </td>
              </tr>
              <tr v-if="siteData.stats.backhaul && (isTelco() || (canAccess('finance|mangement|maintenance|project')))">
                <td><i class="fa fa-broadcast-tower" />&nbsp;Backhaul:</td><td>
                  <el-button type="info" size="mini" plain round @click="menu('backhaul')">{{siteData.stats.backhaul}}</el-button>
                </td>
              </tr>
         </table>
      </el-card>
    </el-col>


    <el-col :sm="24" :md="12" :lg="8">
      <br >
      <el-card shadow="hover">
         <template #header><div class="clearfix">
           <span class="text-success"><i class="fa fa-globe" />&nbsp;Locality</span>
         </div></template>

        <table class="el-table">
          <tr v-if="siteData.latitude || siteData.longitude">
            <td>Geo:</td>
            <td><span>
             lat: <strong>{{siteData.latitude}}</strong>
             lng: <strong>{{siteData.longitude}}</strong>
            </span>
          </td>
          </tr>
          <tr v-if="siteData.address">
            <td>Address:</td><td><strong>{{siteData.address}}</strong></td>
          </tr>
          <tr v-if="siteData.zone">
            <td></td><td><strong>{{siteData.zone}}</strong></td>
          </tr>
          <tr v-if="siteData.subdistrict || siteData.district">
            <td></td><td><i>{{siteData.subdistrict}}</i>
              <i v-if="siteData.district"><span v-if="siteData.subdistrict">,
              </span>{{siteData.district}}</i></td>
          </tr>
          <tr v-if="siteData.state">
            <td></td><td>{{siteData.state}}</td>
          </tr>
          <tr v-if="siteData.region">
            <td></td><td><strong>{{siteData.region}}</strong></td>
          </tr>
          <tr v-if="siteData.country">
            <td></td><td><strong>{{siteData.country}}</strong></td>
          </tr>
        </table>
      </el-card>

    </el-col>
    </el-row>



    <el-row v-if="isTowerCo()" :gutter="24">

      <el-col  v-if="siteData.stats.assets > 0" :sm="24" :md="12" :lg="8">
        <br >

        <el-card  shadow="hover">
          <template #header><div class="clearfix">
            <span class="text-info"><i class="fa fa-cogs" />&nbsp;Equipment</span>
          </div></template>

          <table class="el-table">
            <tr v-if="siteData.stats.assetMW">
              <td>MW:</td><td><strong>{{siteData.stats.assetMW}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetRRU">
              <td>RRU:</td><td><strong>{{siteData.stats.assetRRU}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetTX">
              <td>TX:</td><td><strong>{{siteData.stats.assetTX}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetFibre">
              <td>Fibre:</td><td><strong>{{siteData.stats.assetFibre}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetPanel">
              <td>Panel:</td><td><strong>{{siteData.stats.assetPanel}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetAAUPanel">
              <td>AAU Panel:</td><td><strong>{{siteData.stats.assetAAUPanel}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetRFPanel">
              <td>RF Panel:</td><td><strong>{{siteData.stats.assetRFPanel}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetAAS">
              <td>AAS:</td><td><strong>{{siteData.stats.assetAAS}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetGrid">
              <td>Grid:</td><td><strong>{{siteData.stats.assetGrid}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetMeter">
              <td>Meter:</td><td><strong>{{siteData.stats.assetMeter}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetOwnMeter">
              <td>Own Meter:</td><td><strong>{{siteData.stats.assetOwnMeter}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetCables">
              <td>Cables:</td><td><strong>{{siteData.stats.assetCables}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetCabin">
              <td>Cabin:</td><td><strong>{{siteData.stats.assetCabin}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetOutdoor">
              <td>Outdoor:</td><td><strong>{{siteData.stats.assetOutdoor}}</strong></td>
            </tr>
            <tr v-if="siteData.stats.assetOthers">
              <td>Others:</td><td><strong>{{siteData.stats.assetOthers}}</strong></td>
            </tr>

          </table>

        </el-card>
      </el-col>



    <el-col  v-if="siteData.stats.services > 0" :sm="24" :md="12" :lg="8">
      <br >

      <el-card  shadow="hover">
        <template #header><div class="clearfix">
          <span class="text-info"><i class="fa fa-wifi" />&nbsp;Services ({{siteData.stats.services}})</span>
        </div></template>

        <table class="el-table">
          <tr v-if="siteData.stats.service5G">
            <td>5G:</td><td><strong>{{siteData.stats.service5G}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.service4G">
            <td>4G:</td><td><strong>{{siteData.stats.service4G}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.service3G">
            <td>3G:</td><td><strong>{{siteData.stats.service3G}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.service2G">
            <td>2G:</td><td><strong>{{siteData.stats.service2G}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.serviceCMDA">
            <td>CMDA:</td><td><strong>{{siteData.stats.serviceCMDA}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.serviceHPSA">
            <td>HPSA:</td><td><strong>{{siteData.stats.serviceHPSA}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.serviceFDD">
            <td>FDD:</td><td><strong>{{siteData.stats.serviceFDD}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.serviceLTE">
            <td>LTE:</td><td><strong>{{siteData.stats.serviceLTE}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.serviceTDD">
            <td>TDD:</td><td><strong>{{siteData.stats.serviceTDD}}</strong></td>
          </tr>
          <tr v-if="siteData.stats.serviceUMTS">
            <td>UMTS:</td><td><strong>{{siteData.stats.serviceUMTS}}</strong></td>
          </tr>

        </table>

      </el-card>
    </el-col>


    <el-col v-if="siteData.status != 'Sold' && siteData.status != 'Dismantled'"  :sm="24" :md="12" :lg="8">
      <br >

      <el-card  shadow="hover">
        <template #header><div class="clearfix">
          <span class="text-info"><i class="fa fa-qrcode" />&nbsp;QR Code</span>
        </div></template>

        <qr-code v-if="qrCode && isTowerCo()" :text="qrCode" :color="xolasClient().colourCode" :label="siteData.siteId" :file-name="siteData.siteId" :bw-background="true" />

      </el-card>
    </el-col>
    <br />

    <el-col :span="24" v-if="!isCandidate(siteData.status)">
     <site-attachments :row-data="rowData" />
   </el-col>

  </el-row>

</div>
</template>


<script>

import QrCodeMixins from '@/mixins/QrCodeMixins'
import SiteMixins from '@/mixins/SiteMixins'

import QrCode from '@/components/atoms/QrCode'
import SiteAttachments from '@/components/sites/SiteAttachments'
import ContactsPopover from '@/components/atoms/ContactsPopover'

export default {

  mixins: [SiteMixins, QrCodeMixins],

  components: {
    ContactsPopover,
    SiteAttachments,
    QrCode
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },

  computed: {

    hasStats: function () {
      let s = this.siteData.stats
      if (s) {
        return (s.assets || s.tickets || s.sharers || s.terminate || s.permits || s.actions || s.backhaul)
      } else {
        return false
      }
    },

    showSave: function () {
      if (this.origData) {

        if (this.origData.status === this.activeSite() && !this.origData.active) {
          return true
        }

        if (this.origData.status === this.dismantledSite() && !this.origData.dismantled) {
          return true
        }

        return false

      } else {
        return false
      }
    }
  },


  methods: {

    successEquip (data) {
      this.equipList = data
      this.qrCode = this.qrTextSite(this.siteData, this.equipList)

    },

    menu (view) {
      this.$emit('view', view)
    }

  },

  data () {
    return {
      siteData: this.rowData,
      equipList: [],
      qrCode: null
    }
  },

  created () {
    this.fetchData('/assets/site/' + this.siteData.id + '/qrcode', this.successEquip)
  }

}
</script>
